import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { APIUrl } from "../../constants";
import * as api from '../../tools/apiMiddleware';

const initialState = {
    isLoading: true, canReturnBack: false, data: {}
};

export const programmeCategoryStore = {
    getCategory: (programmeId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.ProgrammeCategory + `/${programmeId}`;
        await api.getRequest(dispatch, url, actionTypes.GET_PROGRAMME_CATEGORY, actionTypes.GET_PROGRAMME_CATEGORY_SUCCESS, actionTypes.GET_PROGRAMME_CATEGORY_FAIL);

    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.PROGRAMME_CATEGORY_CLEAR_ERROR });

    },
    updateLevel: (programmeId, level, levelId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.ProgrammeCategoryProductionType + `/${programmeId}/${level}`;
        await api.updateRequest(dispatch, url, { Id: levelId, Name: '' }, actionTypes.UPDATE_PROGRAMME_CATEGORY, actionTypes.UPDATE_PROGRAMME_CATEGORY_SUCCESS, actionTypes.UPDATE_PROGRAMME_CATEGORY_FAIL);

    },
    updateFormat: (programmeId, formatId) => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.ProgrammeCategoryFormat + `/${programmeId}`;
        await api.updateRequest(dispatch, url, { Id: formatId, Name: '' }, actionTypes.UPDATE_PROGRAMME_CATEGORY, actionTypes.UPDATE_PROGRAMME_CATEGORY_SUCCESS, actionTypes.UPDATE_PROGRAMME_CATEGORY_FAIL);

    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.GET_PROGRAMME_CATEGORY:
            return {
                ...state,
                data: state.data,
                isLoading: true,
                hasErrorOccured: false,
                productionTypeUpdated: false
            };
        case actionTypes.GET_PROGRAMME_CATEGORY_SUCCESS:
            return {
                ...state,
                data: action.data,
                isLoading: false,
                hasErrorOccured: false,
                productionTypeUpdated: false
            };
        case actionTypes.GET_PROGRAMME_CATEGORY_FAIL:
            return {
                ...state,
                isLoading: false,
                data: state.data,
                hasErrorOccured: true,
                errorData: action.data,
                productionTypeUpdated: false
            };
        case actionTypes.PROGRAMME_CATEGORY_CLEAR_ERROR:
            return {
                ...state,
                hasErrorOccured: false
            };
        case actionTypes.UPDATE_PROGRAMME_CATEGORY:
            return {
                ...state,
                hasErrorOccured: false,
                productionTypeUpdated: false
            };
        case actionTypes.UPDATE_PROGRAMME_CATEGORY_SUCCESS:
            return {
                ...state,
                hasErrorOccured: false,
                productionTypeUpdated: true
            };
        case actionTypes.UPDATE_PROGRAMME_CATEGORY_FAIL:
            return {
                ...state,
                hasErrorOccured: true,
                errorData: action.data
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/NonLinear/ProgrammeCategoryStore.js